var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sidebarMain" },
    [
      _c(
        "el-scrollbar",
        {
          staticClass: "sidebar-container",
          attrs: { "wrap-class": "scrollbar-wrapper" }
        },
        [
          _c(
            "el-menu",
            {
              attrs: {
                "show-timeout": 200,
                "default-active": _vm.pathActive,
                "unique-opened": true,
                collapse: _vm.isCollapse,
                mode: "vertical",
                "background-color": "#fff",
                "text-color": "#6d6d6d",
                "active-text-color": "#ec5124"
              }
            },
            [
              _vm._l(_vm.menu, function(item) {
                return [
                  item.isLogo
                    ? _c(
                        "div",
                        {
                          key: item.name + Math.random(),
                          staticClass: "logo_div"
                        },
                        [_vm._v("工单系统")]
                      )
                    : [
                        _c(
                          "el-menu-item",
                          {
                            key: item.name + Math.random(),
                            staticClass: "menu-item",
                            attrs: { index: item.href, title: item.name },
                            on: {
                              click: function($event) {
                                return _vm.onClickMenu(item)
                              }
                            }
                          },
                          [
                            _c("i", { class: item.icon }),
                            _vm._v(" "),
                            _c(
                              "span",
                              { attrs: { slot: "title" }, slot: "title" },
                              [_vm._v(_vm._s(item.name))]
                            )
                          ]
                        )
                      ]
                ]
              }),
              _vm._v(" "),
              _c(
                "el-menu-item",
                {
                  directives: [
                    {
                      name: "permission",
                      rawName: "v-permission",
                      value: "TICKET_MORE_VIEW_AUTH",
                      expression: "'TICKET_MORE_VIEW_AUTH'"
                    }
                  ],
                  key: "setting",
                  staticClass: "hide-if-not-system-user el-submenu-2",
                  attrs: { title: "设置", index: "999" },
                  on: {
                    click: function($event) {
                      return _vm.$router.push("/ticket-vue/setting")
                    }
                  }
                },
                [
                  _c("i", { staticClass: "el-icon-s-tools" }),
                  _vm._v(" "),
                  _c("span", { attrs: { slot: "title" }, slot: "title" }, [
                    _vm._v("工单设置")
                  ])
                ]
              )
            ],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7973fd09", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7973fd09","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sidebar/SideBar.vue
// module id = 431
// module chunks = 75